import { Box, Container, Link, Typography } from "@mui/material";
import React from "react";
import LogoIcon from "./LogoIcon";

const Footer = () => {
  return (
    <Container>
      <Box textAlign="center" p={4}>
        <LogoIcon color="action" fontSize="large" />
        <Typography variant="body2" color="text.secondary">
          Copyright © 2023 Rousen
        </Typography>
        <Link href="/" variant="body2">
          Privacy Policy
        </Link>
        <Link href="/" variant="body2" ml={2}>
          Terms of service
        </Link>
      </Box>
    </Container>
  );
};

export default Footer;
